import LocalizedImage from '@CS/components/LocalizedImage';
import CloseButton from '@/components/CloseButton';
import Images, { Logo } from '@/assets/images';
import { openHome } from '@/services/app/mcd';
import { useNavigateQuery } from '@/hooks';
import { useTranslation } from '@CS/hooks';
import Button from '@CS/components/Button';
import CSS from './Home.module.css';
import Content from './content';

export const Home = () => {
  const {
    title,
    description,
    button,
    terms,
    termsLabel,
    termsLink
  } = useTranslation(Content);

  const navigate = useNavigateQuery();
  const onClick = () => navigate('/quizzes');

  return (
    <section className={CSS.homeScreen} aria-label="Home">
      <CloseButton onClick={openHome} />

      <img alt="Logo" src={Logo} />
      <LocalizedImage name="The Good Trivia" images={Images.Intro} />

      <div className={CSS.descriptionContainer}>
        <h4>{title}</h4>
        <p dangerouslySetInnerHTML={{ __html: description }} />
        <Button text={button} onClick={onClick} />
      </div>

      <span className={CSS.termsLabel}>
        {terms}{' '}
        <a title={termsLabel} href={termsLink}>
          {termsLabel}
        </a>
      </span>
    </section>
  );
};
